module.exports = __webpack_public_path__ + "static/media/Boulder.17b2c617.jpg";